export const URL_FILTER_ID = {
    DS_SKU : "ds_sku_agg",
    COMPETITOR_CATEGORIES : "competitor_scan_categories",
    COMPETITOR_SPECIFIC : "competitor_scan_item_specific"
}